import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {

  GET_CONTRACTED_IPA_REQUEST: '',
  GET_CONTRACTED_IPA_SUCCESS: '',
  GET_CONTRACTED_IPA_FAILURE: '',

  GET_ALL_IPAS_REQUEST: '',
  GET_ALL_IPAS_SUCCESS: '',
  GET_ALL_IPAS_FAILURE: '',

  GET_ALL_IPAS_DESC_REQUEST: '',
  GET_ALL_IPAS_DESC_SUCCESS: '',
  GET_ALL_IPAS_DESC_FAILURE: '',

  GET_IPA_RESOURCES_REQUEST: '',
  GET_IPA_RESOURCES_SUCCESS: '',
  GET_IPA_RESOURCES_FAILURE: '',

  DELETE_RESOURCES_REQUEST: '',
  DELETE_RESOURCES_SUCCESS: '',
  DELETE_RESOURCES_FAILURE: '',

  UPDATE_RESOURCES_REQUEST: '',
  UPDATE_RESOURCES_SUCCESS: '',
  UPDATE_RESOURCES_FAILURE: '',

  UPLOAD_RESOURCES_REQUEST: '',
  UPLOAD_RESOURCES_SUCCESS: '',
  UPLOAD_RESOURCES_FAILURE: '',

  UPLOAD_PROVIDER_RESOURCES_REQUEST: '',
  UPLOAD_PROVIDER_RESOURCES_SUCCESS: '',
  UPLOAD_PROVIDER_RESOURCES_FAILURE: '',

  SEARCH_PROVIDER_REQUEST: '',
  SEARCH_PROVIDER_SUCCESS: '',
  SEARCH_PROVIDER_FAILURE: '',

  SEARCH_SPECIALTY_REQUEST: '',
  SEARCH_SPECIALTY_SUCCESS: '',
  SEARCH_SPECIALTY_FAILURE: '',

  DELETE_DOCUMENTS_REQUEST: '',
  DELETE_DOCUMENTS_SUCCESS: '',
  DELETE_DOCUMENTS_FAILURE: '',

  UPDATE_DOCUMENTS_REQUEST: '',
  UPDATE_DOCUMENTS_SUCCESS: '',
  UPDATE_DOCUMENTS_FAILURE: '',
};

types = setStoreTypeValues(types, 'appIPA');

export default types;
